import NewCustomer from "../pages/customer/manageCustomer/NewCustomer";
import DetailCustomer from "../pages/customer/manageCustomer/DetailedCustomer";
import EditCustomer from "../pages/customer/manageCustomer/EditCustomer";
import ManageCustomer from "../pages/customer/manageCustomer/ManageCustomer";
import casaAccountDetails from "../pages/customer/manageCustomer/DetailedCustomer/components/casaAccountDetails/casaAccountDetails";
import NewAddress from "../pages/customer/manageCustomer/DetailedCustomer/tabs/address/NewAddress";
import EditAddress from "../pages/customer/manageCustomer/DetailedCustomer/tabs/address/EditAddress";
import NewRelationship from "../pages/customer/manageCustomer/DetailedCustomer/tabs/relationship/NewRelationship";
import EditRelationship from "../pages/customer/manageCustomer/DetailedCustomer/tabs/relationship/EditRelationship";
import DetailCharge from "../pages/customer/manageCustomer/DetailedCustomer/tabs/charges/DetailCharge";
import PayCharge from "../pages/customer/manageCustomer/DetailedCustomer/tabs/charges/PayCharge";
import ManageCollateral from "../pages/collateral/ManageCollateral";
import NewCollateral from "../pages/collateral/NewCollateral";
import DetailedCollateral from "../pages/collateral/DetailedCollateral";
import EditCollateral from "../pages/collateral/EditCollateral";
import CollateralMainActionPage from "../pages/collateral/actions/CollateralMainActionPage";

export default [
  {
    path: "/cst0100",
    component: ManageCustomer,
    isProtected: true,
  },
  {
    path: "/edit-customer",
    component: EditCustomer,
    isProtected: true,
  },
  {
    path: "/detail-customer",
    component: DetailCustomer,
    isProtected: true,
  },
  {
    path: "/new-customer",
    component: NewCustomer,
    isProtected: true,
  },
  {
    path: "/manage-collateral",
    component: ManageCollateral,
    isProtected: true,
  },
  {
    path: "/new-collateral",
    component: NewCollateral,
    isProtected: true,
  },
  {
    path: "/edit-collateral",
    component: EditCollateral,
    isProtected: true,
  },
  {
    path: "/detail-collateral",
    component: DetailedCollateral,
    isProtected: true,
  },
  {
    path: "/collateral-action",
    component: CollateralMainActionPage,
    isProtected: true,
  },
  {
    path: "/new-address",
    component: NewAddress,
    isProtected: true,
  },
  {
    path: "/edit-address",
    component: EditAddress,
    isProtected: true,
  },
  {
    path: "/casa-account-details",
    component: casaAccountDetails,
    isProtected: true,
  },

  {
    path: "new-relationship",
    component: NewRelationship,
    isProtected: true,
  },
  {
    path: "edit-relationship",
    component: EditRelationship,
    isProtected: true,
  },
  {
    path: "/detail-charge",
    component: DetailCharge,
    isProtected: true,
  },
  {
    path: "/pay-charge",
    component: PayCharge,
    isProtected: true,
  },
];
